export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';

export const setSelectedFilters = (category, label) => ({
  type: SET_SELECTED_FILTERS,
  payload: { category, label },
});
